import { Label } from "reactstrap";
import "../assets/style/SearchBox.css";
import Select from "react-select";
import "../assets/style/SelectBox.css";
import { SelectOptionBooleanType, SelectOptionType } from "../utils/Types";
import { useState } from "react";

interface ISelectBoxProps {
  options: any;
  label?: string;
  className?: string;
  value?: SelectOptionType | SelectOptionBooleanType;
  closeMenuOnSelect?: boolean;
  isMulti?: boolean;
  onChange?: (event: any) => void;
  customStyles?: any;
  placeholder?: string;
}

const SelectBox: React.FunctionComponent<ISelectBoxProps> = ({
  options,
  label,
  className,
  value,
  closeMenuOnSelect,
  onChange,
  isMulti,
  customStyles,
  placeholder,
}) => {
  const [isClearable, setClearable] = useState<boolean>(false);

  const customSelectStyles = {
    ...customStyles,
    menu: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  return (
    <div className="mb-3">
      {label && <Label className="mb-1 text-start search-label">{label}</Label>}
      <div className={`close ${className}`}>
        <Select
          styles={customSelectStyles}
          isMulti={isMulti ? isMulti : false}
          closeMenuOnSelect={!closeMenuOnSelect ? closeMenuOnSelect : true}
          value={value}
          options={options?.filter((each: any) => each.status !== false)}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={() => {
            setClearable(true);
          }}
          onBlur={() => {
            setClearable(false);
          }}
          isClearable={isClearable}
        />
      </div>
    </div>
  );
};

export default SelectBox;
